var _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDevnet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46973,40.53027l16,16,1.06054-1.06054L11.06055,40,26.53027,24.53027l-1.06054-1.06054-16,16A.74972.74972,0,0,0,9.46973,40.53027Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.11146,
    y: 39.24991,
    width: 35.77709,
    height: 1.50017,
    transform: "translate(-13.66563 57.88854) rotate(-63.43495)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.53027,39.46973l-16-16-1.06054,1.06054L68.93945,40,53.46973,55.46973l1.06054,1.06054,16-16A.74972.74972,0,0,0,70.53027,39.46973Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDevnet);
export default __webpack_public_path__ + "static/media/icon_devnet.59b83669e81afe4ca8a15144a812f3ca.svg";
export { ForwardRef as ReactComponent };